// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-container {
    max-height: 400px; 
    overflow-y: auto;
}

/* Progress bar styling */
.progress {
    background-color: #e9ecef;
    border-radius: 0.375rem;
    overflow: hidden;
}

.progress-bar {
    background-color: #007bff;
    transition: width 0.3s ease;
}

.progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 1rem 1rem;
}

.progress-bar-animated {
    animation: progress-bar-stripes 1s linear infinite;
}

@keyframes progress-bar-stripes {
    0% { background-position: 1rem 0; }
    100% { background-position: 0 0; }
}

/* Processing state styling */
.processing-container {
    text-align: center;
    padding: 2rem;
}

.processing-container h6 {
    color: #495057;
    margin-bottom: 1rem;
}

.processing-container .text-muted {
    color: #6c757d !important;
}

/* Alert styling */
.alert {
    border: 1px solid transparent;
    border-radius: 0.375rem;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
}

.alert-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeaa7;
}

.alert i {
    font-size: 1.1em;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/excel-uploader-modal/excel-uploader-modal.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,qMAAqM;IACrM,0BAA0B;AAC9B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,KAAK,2BAA2B,EAAE;IAClC,OAAO,wBAAwB,EAAE;AACrC;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".preview-container {\n    max-height: 400px; \n    overflow-y: auto;\n}\n\n/* Progress bar styling */\n.progress {\n    background-color: #e9ecef;\n    border-radius: 0.375rem;\n    overflow: hidden;\n}\n\n.progress-bar {\n    background-color: #007bff;\n    transition: width 0.3s ease;\n}\n\n.progress-bar-striped {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n    animation: progress-bar-stripes 1s linear infinite;\n}\n\n@keyframes progress-bar-stripes {\n    0% { background-position: 1rem 0; }\n    100% { background-position: 0 0; }\n}\n\n/* Processing state styling */\n.processing-container {\n    text-align: center;\n    padding: 2rem;\n}\n\n.processing-container h6 {\n    color: #495057;\n    margin-bottom: 1rem;\n}\n\n.processing-container .text-muted {\n    color: #6c757d !important;\n}\n\n/* Alert styling */\n.alert {\n    border: 1px solid transparent;\n    border-radius: 0.375rem;\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 1rem;\n}\n\n.alert-warning {\n    color: #856404;\n    background-color: #fff3cd;\n    border-color: #ffeaa7;\n}\n\n.alert i {\n    font-size: 1.1em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
